<template>
  <div id="app" class="min-h-screen flex flex-col bg-[#2d3fa6]">
    <main class="flex-1">
      <router-view />
    </main>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
